<template>
  <title-block :title="`Sections Beyond Oncology`" color-theme="primary-color">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 color0">
          <div class="title">Gerotaget / Aging</div>
          <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
            dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div>
        </div>
        <div class="col-12 col-md-6 color1">
          <div class="title">Pathology beyond Oncology</div>
          <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
            dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.
            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div>
        </div>
        <div class="col-12 col-md-6 color2">
          <div class="title">Immunology & Microbiology</div>
          <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
            dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div>
        </div>
        <div class="col-12 col-md-6 color3">
          <div class="title">Autophagy & Cell Death</div>
          <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
            dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div>
        </div>
        <div class="col-12 col-md-6 color4">
          <div class="title">Chromosome</div>
          <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
            dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div>
        </div>
      </div>
    </div>
  </title-block>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  export default {
    name: 'sections-beyond-oncology',
    components: {
      TitleBlock
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
  .row > div {
    margin-top: 28px;
    padding-bottom: 27px;
    font-family: OpenSans;
    font-size: 14px;
    line-height: 1.21;
    text-align: left;
    color: $accent-color-3;

    &:not(:last-child) {
      border-bottom: 1px solid rgba($black, 0.1);
    }
    @media(min-width: 768px) {
      &:nth-last-child(2):nth-child(odd) {
        border-bottom: none;
      }
    }
    &:before {
      content: "";
      position: absolute;
      height: calc(100% - 30px);
      left: 0;
      top: 5px;
    }
    &:after {
      content: "";
      position: absolute;
      height: 16px;
      width: 8px;
      background-color: $black;
      left: 0;
      top: 5px;
    }
    &.color0:after {
      background-color: #ffae00;
    }
    &.color1:after {
      background-color: #6bca00;
    }
    &.color2:after {
      background-color: #f13700;
    }
    &.color3:after {
      background-color: #ebc5df;
    }
    &.color4:after {
      background-color: #6faee8;
    }
    @media(min-width: 768px) {
      &:nth-child(even):before {
        border-left: 1px solid rgba($black, 0.1);
      }
    }
    .title {
      font-family: Merriweather;
      font-size: 20px;
      font-weight: 300;
      line-height: 1.25;
      text-align: left;
      color: #ed643f;
      margin-bottom: 19px;
    }
  }
</style>



// WEBPACK FOOTER //
// SectionsBeyondOncologyComponent.vue?4242986d